import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ko: {
    translation: {
      "brand.tagline": "모국어로 말해도, 상대의 마음에 그대로 닿는다.",
      "cta.start": "지금 시작하기",
      "nav.home": "홈",
      "nav.matches": "매칭",
      "nav.chat": "채팅",
      "nav.profile": "프로필",
      "home.hero.eyebrow": "한·일 실시간 통역 데이팅",
      "home.hero.title": "설렘은 그대로, 대화는 모국어로.",
      "home.hero.sub":
        "Gemma 4 기반 실시간 통역으로, 언어 장벽 없이 진짜 대화를 만드세요.",
      "home.feature.translate.title": "실시간 채팅 통역",
      "home.feature.translate.sub":
        "한국어로 보내도, 상대에게는 자연스러운 일본어로 도착합니다.",
      "home.feature.video.title": "영상통화 자막",
      "home.feature.video.sub":
        "상·하 분할 화면 + 실시간 자막으로 얼굴 보며 모국어로 대화.",
      "home.feature.trust.title": "파란 체크 인증",
      "home.feature.trust.sub":
        "얼굴-ID 매칭으로 검증된 회원만 추천 풀에 노출됩니다.",
      "home.feature.niche.title": "한·일 전용",
      "home.feature.niche.sub":
        "한국 남성 × 일본 여성 전용 큐레이션. 수요·문화에 맞춘 매칭.",
    },
  },
  ja: {
    translation: {
      "brand.tagline": "母国語で話しても、相手の心にそのまま届く。",
      "cta.start": "今すぐ始める",
      "nav.home": "ホーム",
      "nav.matches": "マッチ",
      "nav.chat": "チャット",
      "nav.profile": "プロフィール",
      "home.hero.eyebrow": "日韓リアルタイム通訳デーティング",
      "home.hero.title": "ときめきはそのまま、会話は母国語で。",
      "home.hero.sub":
        "Gemma 4 によるリアルタイム通訳で、言葉の壁なく本物の会話を。",
      "home.feature.translate.title": "リアルタイムチャット通訳",
      "home.feature.translate.sub":
        "日本語で送っても、相手には自然な韓国語で届きます。",
      "home.feature.video.title": "ビデオ通話字幕",
      "home.feature.video.sub":
        "上下分割 + リアルタイム字幕で、顔を見ながら母国語で会話。",
      "home.feature.trust.title": "青チェック認証",
      "home.feature.trust.sub":
        "顔とIDの照合で認証済みのユーザーのみがレコメンドに登場。",
      "home.feature.niche.title": "日韓専用",
      "home.feature.niche.sub":
        "韓国人男性 × 日本人女性に特化したキュレーション。",
    },
  },
} as const;

const saved =
  (typeof localStorage !== "undefined" && localStorage.getItem("kj-locale")) ||
  (typeof navigator !== "undefined" &&
  navigator.language?.toLowerCase().startsWith("ja")
    ? "ja"
    : "ko");

void i18n.use(initReactI18next).init({
  resources,
  lng: saved,
  fallbackLng: "ko",
  interpolation: { escapeValue: false },
});

export default i18n;
